'use strict'

module.exports = blockquote

var wrapChildren = require('../util/wrap-children')

function blockquote(h, node) {
  return h(node, 'blockquote', wrapChildren(h, node))
}
